import last from 'lodash-es/last';
import React, { useMemo } from 'react';
import { useDashboardFeatureFlags } from '@components';
import { DatePicker, Select } from '@fourthwall/components';
import { isDateRangeValue, isPrecisionValue, mapDateRangeValueToPrecisionOptions, useDateRange, usePrecision, } from '@fourthwall/module-analytics';
import { useShopTime } from '@modules/Timezone/providers/ShopTimeProvider';
import { useAnalyticsParams } from '../../hooks/useAnalyticsParams';
import * as S from './RangeSelect.styled';
export const RangeSelect = ({ excludedPrecision }) => {
    const { timezoneAbbreviation, getCurrentShopTime, toShopTime, convertToDate } = useShopTime();
    const { dateRange } = useDateRange(getCurrentShopTime());
    const { precision } = usePrecision(dateRange.value, excludedPrecision);
    const { queryParams: { from: [fromParam, setFromParam], to: [toParam, setToParam], }, } = useAnalyticsParams();
    const { dashboardFeatureFlags } = useDashboardFeatureFlags();
    const isTimezoneEnabled = dashboardFeatureFlags.timezone.enabled;
    const rangePickerValue = useMemo(() => {
        const from = fromParam ? convertToDate(fromParam) : undefined;
        const to = toParam ? convertToDate(toParam) : undefined;
        return [from, to];
    }, [convertToDate, fromParam, toParam]);
    const onSelectValueChange = (value) => {
        dateRange.select.onValueChange(value);
        setFromParam(value === 'custom' ? dateRange.params?.from || '' : undefined);
        setToParam(value === 'custom' ? dateRange.params?.to || '' : undefined);
        if (isDateRangeValue(value)) {
            const newPrecisionValue = last(mapDateRangeValueToPrecisionOptions(value, excludedPrecision))?.value;
            if (newPrecisionValue && isPrecisionValue(newPrecisionValue)) {
                precision.setValue(newPrecisionValue);
            }
        }
    };
    const onRangeValueChange = ([startDate, endDate]) => {
        const value = startDate > endDate ? [endDate, startDate] : [startDate, endDate];
        const from = toShopTime(value[0]).startOf('day').format();
        const to = toShopTime(value[1]).endOf('day').format();
        setFromParam(from);
        setToParam(to);
    };
    const renderRangePicker = () => {
        if (dateRange.value === 'custom') {
            const props = {
                type: 'range',
                value: rangePickerValue,
                size: 'medium',
                labels: isTimezoneEnabled ? ['From', 'To'] : ['From (UTC)', 'To (UTC)'],
                onChange: onRangeValueChange,
            };
            return React.createElement(DatePicker, { ...props });
        }
        return null;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(S.SelectContainer, null,
            React.createElement(Select, { label: `Date range (${isTimezoneEnabled ? timezoneAbbreviation : 'UTC'})`, options: dateRange.select.options, size: "medium", value: dateRange.value, onValueChange: onSelectValueChange })),
        renderRangePicker()));
};
